"use client";

import { useEffect, useState } from "react";
import { PipelineLocatorMap } from "../../../../blocks/PipelineLocatorBlock/PipelineLocatorMap";
import { PipelineLocatorGoogleMapsAPIProvider } from "../../../../blocks/PipelineLocatorBlock/PipelineLocatorGoogleMapsAPIProvider";

interface CheckGasAvailableCardProps {
	address: string;
	children: React.ReactNode;
	/** Reports whether the address has a gas connection, once known. */
	onAvailabilityChange?: (isAvailable: boolean) => void;
}

export const CheckGasAvailableCard = ({
	address,
	children,
	onAvailabilityChange,
}: CheckGasAvailableCardProps) => {
	const [isValid, setIsValid] = useState<boolean | undefined>(false);

	useEffect(() => {
		setIsValid(false);
	}, [address]);

	if (!isValid) {
		return (
			<div style={{ display: isValid === false ? "block" : "none", width: "100%" }}>
				<PipelineLocatorGoogleMapsAPIProvider>
					<PipelineLocatorMap
						address={address}
						callback={isValid => {
							setIsValid(isValid);
							onAvailabilityChange?.(isValid);
						}}
					/>
				</PipelineLocatorGoogleMapsAPIProvider>
			</div>
		);
	}

	return children;
};
